import { Box, Button, Divider, FormControl, IconButton, InputLabel, makeStyles, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, withStyles } from '@material-ui/core';
import { NavigateBefore, NavigateNext } from '@material-ui/icons';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getTotalPembelian, setMessageSave } from '../../config/redux/action';
import Cookies from 'js-cookie';
import MuiAlert from '@material-ui/lab/Alert';


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

const TotalOmzetPembelian = () => {
    const useStyle = makeStyles((theme)=>({
    root:{
        width:'100%',
        height:'100%',
        alignItems:'center',
    },
    header:{
        display:'flex',
        textAlign:'center',
        flexDirection:'column',
        justifyContent:'center',
        padding:'5px',
    },
    title:{
        paddingTop:'10px',
        textAlign:'center'
    },
    radioGroup:{
        width:'99vw',
        display:'flex',
        flexDirection:'row',
        justifyContent:'center'
    },tableContainer:{
            height:'400px',
            [theme.breakpoints.down('xs')]:{
                height:'420px'
            },
        },page:{
            display:'flex',
            width:'100%',
            margin:'0px',
        },paper:{
            display:'flex',
            flexDirection:'column',
            justifyContent:'center',
            width:'40%',
            minWidth:'500px',
            marginTop:'20px',
            [theme.breakpoints.down('xs')]:{
                width:'90%',
            },
        },table:{
            display:'flex',
            flexDirection:'column',
            justifyContent:'center',
            alignItems:'center',
            marginTop:'5px',
            width:'100%',
        },
        GrandTotal:{
            display:'flex',
            justifyContent:'space-between',
            width:'40%',
            marginTop:'10px',
            marginBottom:'10px',
        }
    }))
    const SytledTableCell = withStyles((theme)=>({
        head: {
            backgroundColor: 'grey',
            color: theme.palette.common.black,
          },
          body: {
            fontSize: 14,
            // border:'1px solid black'
          },
    }))(TableCell);
    const StyledTableRow = withStyles((theme) => ({
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      }))(TableRow);
    const classes=useStyle();
    const [bulan, setBulan] = useState(new Date().getMonth() + 1); // default: bulan sekarang (1-12)
    const [tahun, setTahun] = useState(new Date().getFullYear());
    const {data} = useSelector(state => state.loginReducers);
    const {dataTotalPembelian, messageSavePembelian,pageTotalPembelian } = useSelector(state => state.pembelianReducers);
    const [token,setToken] = useState(data.token);
    const [counter,setCounter] = useState(1);
    const handlePrev = () =>{
        setCounter(counter <= 1? 1 : counter - 1);
    }
    const handleNext = () =>{
        setCounter(counter === pageTotalPembelian.totalPage ? pageTotalPembelian.totalPage : counter + 1);
    }
    if(token ===''){
        setToken(Cookies.get('u_tkn'));
    }
    // Daftar bulan dengan label (nama) + value (angka 1-12)
  const bulanList = [
    { value: 1, label: "Januari" },
    { value: 2, label: "Februari" },
    { value: 3, label: "Maret" },
    { value: 4, label: "April" },
    { value: 5, label: "Mei" },
    { value: 6, label: "Juni" },
    { value: 7, label: "Juli" },
    { value: 8, label: "Agustus" },
    { value: 9, label: "September" },
    { value: 10, label: "Oktober" },
    { value: 11, label: "November" },
    { value: 12, label: "Desember" },
  ];
  const dispatch=useDispatch();
  const tahunSekarang = new Date().getFullYear();
  const tahunList = [tahunSekarang - 2, tahunSekarang - 1, tahunSekarang];
  const [openSnackbar,setOpenSnackbar] = useState(false);
  const [totalPembelian,setTotalPembelian]=useState(0);

  useEffect(()=>{
    if((dataTotalPembelian?.length ?? 0) < 1){
        const dataPembelian={
        'page':1,
        'perPage':50,
        'bulan':bulan,
        'tahun':tahun
        }
        dispatch(getTotalPembelian(dataPembelian,token,setOpenSnackbar));
    }
    if(dataTotalPembelian.length>0){
        let totalPembelian=dataTotalPembelian.reduce((Pembelian,TotalP)=>{
                return Pembelian + TotalP.total_pembelian
            },0)
            setTotalPembelian(totalPembelian);
    }
  },[dataTotalPembelian,dispatch,token,bulan,tahun,totalPembelian])
  const handleClickGetPembelian=()=>{
    const dataPembelian={
        'page':1,
        'perPage':50,
        'bulan':bulan,
        'tahun':tahun
    }
    dispatch(getTotalPembelian(dataPembelian,token,setOpenSnackbar));
  }
  const handleCloseSnackBar = () => {
          setOpenSnackbar(false);
          setTimeout(()=>{
              dispatch(setMessageSave(""));
          },200)
      };
    const tableTotalPembelian =(
        <TableBody>
            {dataTotalPembelian && dataTotalPembelian.map((dataTotalPembelians=>(
            <StyledTableRow key={dataTotalPembelians.no_urut}>
                <SytledTableCell align="center">{dataTotalPembelians.no_urut}</SytledTableCell>
                <SytledTableCell align="center">{dataTotalPembelians.namaperusahaan}</SytledTableCell>
                <SytledTableCell align="center">{dataTotalPembelians.periode}</SytledTableCell>
                <SytledTableCell align="center">{new Intl.NumberFormat().format(dataTotalPembelians.total_pembelian)}</SytledTableCell>
            </StyledTableRow>
        )))}
        </TableBody>
    )
  return (
     <div className={classes.root}>
        <div className={classes.header}>
            <Typography variant='h5' className={classes.title}>Laporan Pembelian</Typography>
        </div>
        <Divider/>
        <div className={classes.table}>
                <Box display="flex" alignItems="center" gap={2}>
                <FormControl size="small">
                    <InputLabel>Bulan</InputLabel>
                    <Select
                    value={bulan}
                    onChange={(e) => setBulan(Number(e.target.value))}
                    label="Bulan"
                    >
                    {bulanList.map((b) => (
                        <MenuItem key={b.value} value={b.value}>
                        {b.label}
                        </MenuItem>
                    ))}
                    </Select>
                </FormControl>
                <FormControl size="small" style={{marginLeft:'10px'}}>
                    <InputLabel>Tahun</InputLabel>
                    <Select
                    value={tahun}
                    onChange={(e) => setTahun(Number(e.target.value))}
                    label="Tahun"
                    >
                    {tahunList.map((t) => (
                        <MenuItem key={t} value={t}>
                        {t}
                        </MenuItem>
                    ))}
                    </Select>
                </FormControl>
                <Button
                    style={{marginLeft:'10px'}}
                    variant="contained"
                    color="primary"
                    size='small'
                    onClick={handleClickGetPembelian}
                >
                    Tampilkan
                </Button>
            </Box>
        <Paper className={classes.paper}>
            <TableContainer className={classes.tableContainer}>
                <Table stickyHeader aria-label="table barang" size="small">
                    <TableHead>
                        <TableRow>
                            <SytledTableCell width='10%' align="center">No</SytledTableCell>
                            <SytledTableCell width='10%' align="center">Nama Perusahaan</SytledTableCell>
                            <SytledTableCell width='10%' align="center">Periode</SytledTableCell>
                            <SytledTableCell width='10%' align="center">Total Pembelian</SytledTableCell>
                        </TableRow>
                    </TableHead>
                        {tableTotalPembelian}
                </Table>
            </TableContainer>
                <div className={classes.page}>
                <Tooltip title="Prev">
                    <IconButton size='small'
                        onClick={handlePrev}
                        >
                        <NavigateBefore/>
                    </IconButton>
                </Tooltip>
                <Typography className={classes.textPage}>
                    {pageTotalPembelian.currentPage} / {pageTotalPembelian.totalPage >= 1 ? pageTotalPembelian.totalPage : pageTotalPembelian.currentPage}
                    </Typography>
                <Tooltip title="Next">
                    <IconButton size='small' 
                    onClick={handleNext}
                    >
                        <NavigateNext/>
                    </IconButton>
                </Tooltip> 
                </div>
        </Paper>
        <div className={classes.GrandTotal}>
            <Typography>Total Pembelian</Typography>
            <Typography><b>{new Intl.NumberFormat().format(totalPembelian)}</b></Typography>
        </div>
        </div>
        <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackBar}>
        <Alert onClose={handleCloseSnackBar} 
        severity={messageSavePembelian === "Berhasil menampilkan rincian pembelian" ? "success" : "error"} 
        >
            {messageSavePembelian}</Alert>
        </Snackbar>
    </div>
  )
}

export default TotalOmzetPembelian